module.exports = __webpack_public_path__ + "static/fourvill-board-2-1dd95bb0da7507b9ec4e76497659d1fd.mp4";